import { defineMessages } from 'utils/intl';

export default defineMessages({
  copyright: 'Copyright © {year} {appShortName}. Wszelkie prawa zastrzeżone.',
});
